export const build = { date:"2026-06-08.1339", stage:"alpha" }
